module.exports = __webpack_public_path__ + "img/box3_item_bg1.6c109c62.png";